import { Link } from 'react-router-dom';

import { GlobalAccount, TaskView } from '@ndvr/customer-api';

import { titleCase } from 'utils';
import { formatDate } from 'utils/date-formatter';

import { getTaskAssigneeInitials } from '../task-utils';
import { TaskAssigneeAvatar } from './TaskAssigneeAvatar';
import { TaskRecurrenceChip } from './TaskRecurrenceChip';
import { TaskTypeIcon } from './TaskTypeIcon';

interface TaskCardProps {
    task: TaskView;
    householdMap: Map<string, GlobalAccount>;
    onTitleClick?: (task: TaskView) => void;
}

export const TaskCard = (props: TaskCardProps) => {
    return (
        <div className="space-y-2">
            <div
                className="cursor-pointer text-sm font-medium hover:underline"
                title={props.task.title}
                onMouseDown={(e) => {
                    e.stopPropagation();
                    props.onTitleClick?.(props.task);
                }}
            >
                <div className="flex min-w-0 items-center gap-2">
                    <span className="truncate">{props.task.title}</span>
                    <TaskRecurrenceChip frequency={props.task.frequency} />
                </div>
            </div>

            <div className="text-xs">
                {props.task.householdGUID ? (
                    <Link
                        to={`/household/${props.task.householdGUID}`}
                        className="text-blue-600 hover:text-blue-800 hover:underline"
                        onMouseDown={(e) => e.stopPropagation()}
                    >
                        {props.householdMap.get(props.task.householdGUID)?.globalAccountNamePlain ||
                            'Unknown Household'}
                    </Link>
                ) : (
                    <span className="text-muted-foreground">No household</span>
                )}
            </div>

            {props.task.dueDate && (
                <div className="text-muted-foreground text-xs">Due: {formatDate(props.task.dueDate)}</div>
            )}

            <div className="text-muted-foreground flex items-center justify-between">
                <div className="flex items-center gap-1">
                    <TaskTypeIcon type={props.task.type} />
                    <span className="text-xs">{titleCase(props.task.type)}</span>
                </div>
                {props.task.assignee && (
                    <TaskAssigneeAvatar
                        guid={props.task.assignee}
                        initials={getTaskAssigneeInitials(props.task)}
                        className="h-6 w-6"
                    />
                )}
            </div>
        </div>
    );
};
